"use client"

import ElegantMenuHero from "./components/MenuHero"
import ElegantCategoriesSection from "./components/CategoriesSection"
import ElegantFooter from "./components/Footer"
import BeveragesSection from "@/components/beverages-section"
import OrderStatusModal from "@/components/order-status-modal"
import OrderCompletionModal from "@/components/order-completion-modal"
import ConnectionStatus from "@/components/connection-status"
import NotificationContainer from "@/components/notification-container"
import FloatingNav from "@/components/floating-nav"
import BuffetAd from "@/components/buffet-ad"
import { useApp } from "@/lib/context"

interface MenuTemplateProps {
  isLoading?: boolean
  onLoadingComplete?: () => void
}

export default function ElegantMenu({ isLoading = false, onLoadingComplete }: MenuTemplateProps) {
  const { categoriesBebidas } = useApp()

  return (
    <main className="min-h-screen bg-background text-foreground">
      {/* Elegant Theme: laranja & branco com glassmorfismo */}

      <ElegantMenuHero />

      {/* Anúncio do bufete — convite inicial + banner (todos os temas) */}
      <BuffetAd />

      <ElegantCategoriesSection />

      {categoriesBebidas.length > 0 && (
        <div className="border-t border-primary/20">
          <BeveragesSection />
        </div>
      )}

      <ElegantFooter />

      {/* Modais e overlays partilhados */}
      <OrderStatusModal />
      <OrderCompletionModal />
      <NotificationContainer />
      <ConnectionStatus />
      <FloatingNav />
    </main>
  )
}
